// The sidebar badge is one request on mount and one after every validation or
// return (contract §3.1): no interval. The review page announces the change
// here and whoever shows the count re-reads it.
type Listener = () => void;
const listeners = new Set<Listener>();

export const onLabQueueChanged = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyLabQueueChanged = () => {
  listeners.forEach((listener) => listener());
};
